export default __webpack_public_path__ + "static/media/AtomLogo.ba754ea9.svg";